import { Analytics } from '@cobliteam/analytics';
import { ConditionCategory } from '@cobliteam/api-lib/src/dashboard/alerts/definitions/conditions';
import { RuleCategory } from '@cobliteam/api-lib/src/dashboard/alerts/definitions/rules';
import { Location } from '@cobliteam/common-types';
import { AlertHookType } from '@cobliteam/hooks/src/useAlertHooks/types';
import useTriggerAlertHook from '@cobliteam/hooks/src/useAlertHooks/useTriggerAlertHook';
import { useTranslation } from '@cobliteam/i18n';
import { usePermissions } from '@cobliteam/permissions';
import { Button } from '@cobliteam/ui/components';
import Icon from '@cobliteam/ui/icons';
import queryString from 'query-string';
import type React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { type ProcessedStop, selectSelectedVehicleId } from '../../../../store';
import { StopPopup } from '../../../StopPopup/StopPopup';

export interface MapStopPopupProps {
  stop: ProcessedStop;
  idleTimeHighlighted: boolean;
}

export const MapStopPopup: React.FC<MapStopPopupProps> = ({ stop, idleTimeHighlighted }) => {
  const { t } = useTranslation('tracking');
  const { triggerAlertHook } = useTriggerAlertHook();
  const { isAccessAllowed } = usePermissions();
  const canCreateAlertTrigger = isAccessAllowed('config-and-view:custom-alerts');
  const selectedVehicleId = useSelector(selectSelectedVehicleId);

  const handleCreateIdleEngineRule = async () => {
    Analytics.track('Created Idle Engine Rule by Hook Popup Map');
    const opened = await triggerAlertHook(AlertHookType.IDLE_ENGINE, selectedVehicleId ? { vehicleIds: [selectedVehicleId] } : {}, { force: true });
    if (opened) return;

    const params = queryString.stringify({
      templateRule: RuleCategory.IDLE_ENGINE,
      templateCondition: ConditionCategory.IDLE_ENGINE_10_MINUTES,
      ...(selectedVehicleId && { vehicleId: selectedVehicleId }),
    });
    window.open(`${window.location.origin}/#${Location.ALERTS_TRIGGERS_CREATE}?${params}`, '_blank')?.focus();
  };

  return (
    <StopPopup stop={stop} idleTimeHighlighted={idleTimeHighlighted}>
      <Link to={Location.ALERTS_IDLE_ENGINE} className='flex-1' target='_blank'>
        <Button className='w-full' variant='outlined' size='sm' onClick={() => Analytics.track('Viewed Idle Engine Rules by Hook Popup Map')}>
          {t('access_rules')}
        </Button>
      </Link>
      {canCreateAlertTrigger && (
        <Button variant='outlined' size='sm' startIcon={<Icon name='plus' />} onClick={handleCreateIdleEngineRule}>
          {t('create_idle_engine_rule')}
        </Button>
      )}
    </StopPopup>
  );
};
